import styled from 'styled-components';
import { sx2CssThemeFn } from '@hotelplan/libs.sx';
import { Container } from 'components/core/container';

const PdpPageContainer = styled(Container)(
  sx2CssThemeFn({
    py: ['20px', '30px'],
    px: [3, 4],
    '.recharts-label.label': {
      fontSize: '10px',
      color: 'textGray',
    },
  })
);

export default PdpPageContainer;
